module.exports = __webpack_public_path__ + "img/loading.9df29c2b.gif";